import { type HttpEvent, type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { UserService } from '../state/user.service';

@Injectable()
export class AuthorizationHeaderInterceptor implements HttpInterceptor {
    private readonly userService: UserService = inject(UserService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const token = this.userService.getToken();
        const headers: Record<string, string> = token ? { authorization: `Bearer ${token}` } : {};

        return next.handle(req.clone({
            setHeaders: headers,
        }));
    }
}
